import React from 'react';
import { Variable } from 'src/api/types';

/**
 * Provides the current variable list to the chip node-views and the suggestion popup, both of
 * which render via React portals into the editor tree (so they can read this context).
 * Updating `variables` here re-renders chips with fresh values without re-parsing the doc.
 */
export const VariablesContext = React.createContext<{
  variables: Variable[];
  workspaceVariableNames: Set<string>;
  /**
   * When provided, chip node-views become clickable and call this to open the variables
   * popup targeted at the clicked variable (scroll + focus its value + pulse the row).
   * Optional so consumers that don't wire it keep plain, non-interactive chips.
   */
  onVariableChipClick?: (variableId: number, el: HTMLElement) => void;
}>({
  variables: [],
  workspaceVariableNames: new Set(),
});
